export default __webpack_public_path__ + "static/media/mom-child.a02355c7.jpg";